// feedback.tsx

//@ts-nocheck
import React, {
  Fragment,
  HTMLProps,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  ColumnDef,
  PaginationState,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  Row,
} from "@tanstack/react-table";
import { Link, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { BASE_URL, get } from "../../utils/api";
import { useDispatch } from "react-redux";
import { toast } from "sonner";
import { debounce } from "lodash";
import { Dialog, Label, Listbox, Transition } from "@headlessui/react";
import DocumentHeader from "./JobHeader";
import CustomMenuDropdown from "../../components/common/CustomMenuDropdown";
import { _baseRequest } from "../../utils/apis";
import { getToken } from "../../utils/localStorage";
import axios from "axios";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { DeleteIcon, ExclamationIcon } from "../../components/icons";
import DropDown from "../../components/common/DropDown";
import { ChevronDownIcon, CrossIcon } from "../../components/icons/Icons";
import { DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import {
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import LoadingBar from "react-top-loading-bar";
import { fetchDepartmentList } from "../../features/department/departmentSlice";
import { updateDocument, updateTags } from "../../features/job/jobSlices";
import { useSidebar } from "../../context/SidebarContext";
import { useSidebarMenu } from "../../context/CustomVerticalMenuContext";
import { useSidebarMenuHover } from "../../context/CustomHoverContext";
import { fetchPipelineStagesList } from "../../features/tags/tagsSlice";

type Person = {
  doc_status: any;
  doc_sub_status: any;
  id: any;
  created_at: string | number | Date;
  internal: any;
  doc_tag: any;
  external: any;
  channel_id: any;
  item_refernce_id: ReactNode;
  name: string;
  email: string;
  age: string;
  type: string;
  typeColor: string;
  status: string;
  statusColor: string;
  progress?: string;
  avatar?: string;
};

interface topicTableProps {
  sectionHeight?: number;
}

interface DropdownItem {
  className?: string;
  icon?: ReactNode;
  label: string;
  shortcut?: any;
  disabled?: boolean;
  onClick?: () => void;
  href?: string;
}

interface Status {
  id: number;
  name: string;
  label: string;
}

const statusItem: Status[] = [
  { id: 101, name: "completed", label: "#15803d" },
  { id: 102, name: "rejected", label: "#b91c1c" },
  { id: 103, name: "terminated", label: "#3b82f6" },
  { id: 104, name: "expired", label: "#b91c1c" },
  { id: 105, name: "pending", label: "#854d0e" },
  { id: 106, name: "draft", label: "#4b5563" },
];

localStorage.setItem("itemStatusList", JSON.stringify(statusItem));

const sub_StatusItem: Status[] = [
  { id: 101, name: "completed-view", label: "#15803d" },
  { id: 102, name: "completed", label: "#15803d" },
  { id: 103, name: "completed-accept", label: "#15803d" },
  { id: 104, name: "completed-sign", label: "#15803d" },
  { id: 105, name: "completed-payment", label: "#15803d" },
  { id: 106, name: "pending-accept", label: "#854d0e" },
  { id: 107, name: "pending-sign", label: "#854d0e" },
  { id: 108, name: "pending-payment", label: "#854d0e" },
  { id: 109, name: "pending-input", label: "#854d0e" },
  { id: 110, name: "pending-view", label: "#854d0e" },
  { id: 111, name: "pending-approval", label: "#854d0e" },
  { id: 112, name: "sent", label: "#4b5563" },
  { id: 113, name: "draft", label: "#4b5563" },
];

localStorage.setItem("itemSubStatusList", JSON.stringify(sub_StatusItem));

function IndeterminateCheckbox({
  indeterminate,
  className = "",
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = React.useRef<HTMLInputElement>(null!);

  React.useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className="h-4 w-4 rounded border-gray-300 text-indigo-600 ring-0 outline-none focus:outline-none focus:shadow-none focus:ring-transparent"
      {...rest}
    />
  );
}

var date = new Date();
var formattedDate = date.toLocaleDateString("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

export const colorMap = {
  numbers: {
    "0": "#ffc107",
    "1": "#ff9900",
    "2": "#ffa07a",
    "3": "#e67e73",
    "4": "#d35400",
    "5": "#e74c3c",
    "6": "#f39c12",
    "7": "#ff8c00",
    "8": "#ffb6c1",
    "9": "#ff69b4",
  },
  alphabets: {
    a: "#ff9900",
    b: "#ffc107",
    c: "#ffa07a",
    d: "#e67e73",
    e: "#d35400",
    f: "#e74c3c",
    g: "#f39c12",
    h: "#ff8c00",
    i: "#ffb6c1",
    j: "#ff69b4",
    k: "#ffc499",
    l: "#ffa57d",
    m: "#e6b8a3",
    n: "#d2b48c",
    o: "#ff9900",
    p: "#ffc107",
    q: "#ffa07a",
    r: "#e67e73",
    s: "#d35400",
    t: "#e74c3c",
    u: "#f39c12",
    v: "#ff8c00",
    w: "#ffb6c1",
    x: "#ff69b4",
    y: "#ffc499",
    z: "#ffa57d",
  },
};

export const getColorForLabel = (label: string): string => {
  const firstChar = label?.charAt(0).toLowerCase();
  if (firstChar >= "0" && firstChar <= "9") {
    return (
      colorMap.numbers[firstChar as keyof typeof colorMap.numbers] || "#808080"
    );
  } else if (firstChar >= "a" && firstChar <= "z") {
    return (
      colorMap.alphabets[firstChar as keyof typeof colorMap.alphabets] ||
      "#808080"
    );
  }
  return "#808080";
};

// export default function FeedbackTable() {
const JobList: React.FC<topicTableProps> = ({
  sectionHeight,
  activeFilters,
  itemAssignedTo,
  itemStatusDraft,
  itemStatusPending,
  itemStatusCompleted,
}: any) => {
  const [data, setData] = React.useState<any[]>([]);
  const [pagination, setPagination] = React.useState<PaginationState>({
    pageIndex: 0,
    pageSize: 25,
    currentPage: 1,
    hasNextPage: false,
    totalPages: 1,
    totalItems: 0,
  });
  const [rowSelection, setRowSelection] = React.useState({});
  const [selectedRows, setSelectedRows] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [isModalOpenCheckbox, setIsModalOpenCheckbox] = useState(false);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [deleteOk, setDeleteOk] = useState(false);
  const [rowSelectionDelete, setRowSelectionDelete] = useState<number[]>([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const isInitialMount = useRef(true);
  const [initialLoading, setInitialLoading] = useState(true);
  // Fetch channelData from localStorage
  const channelDataString = localStorage.getItem("channelData");
  const channelData = channelDataString ? JSON.parse(channelDataString) : [];
  const [teams, setTeams] = useState(null);
  const [tagsList, setTagsList] = useState(null);
  const [roleList, setRoleList] = useState([]);
  const [selectRole, setSelectRole] = useState<any>("");
  const { verticleSidebar, setVerticleSidebar } = useSidebar();
  // item status data
  const itemStatus = localStorage.getItem("itemStatusList");
  const statusData = itemStatus ? JSON.parse(itemStatus) : [];

  // item tags data
  const itemTags = localStorage.getItem("itemTagsList");
  const tagsData = itemTags ? JSON.parse(itemTags) : [];

  // item priority
  const itemPriority = localStorage.getItem("priorities");
  const priorityData = itemPriority ? JSON.parse(itemPriority) : [];
  const dispatch = useAppDispatch();
  const [addTags, setAddTags] = useState(false);
  const [tagsOpen, setTagsOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState("");
  const [searchTags, setSearchTags] = useState({});

  const loadingBarRef = useRef(null);
  const { customVerticalSidebar } = useSidebarMenu();
  const { isTooltipHovered } = useSidebarMenuHover();
  const navigate = useNavigate();
   const isChatOpen = useAppSelector((state: any) => state.ui?.isChatbotOpen);

  const _get_ItemFeedbackList = async (
    pageIndex: number,
    pageSize: number,
    filters: Filters,
    assignedTo: boolean,
    itemStatusDraft: boolean,
    itemStatusPending: boolean,
    itemStatusCompleted: boolean
  ) => {
    const baseId =
      localStorage.getItem("UserBaseId") ||
      localStorage.getItem("createBaseId");
    if (!baseId) return;

    try {
      setLoading(true);

      const parsedBaseId = isNaN(Number(baseId)) ? baseId : JSON.parse(baseId);
      const url = `${BASE_URL}/${parsedBaseId}/jobPost.list`;
      const params = new URLSearchParams({
        page: pageIndex.toString(),
        limit: pageSize.toString(),
      });

      // Add filters logic
      if (filters) {
        Object.entries(filters).forEach(([filterType, filterValues]) => {
          if (filterType === "search") return;

          if (Array.isArray(filterValues) && filterValues.length > 0) {
            const keyPrefix = getKeyPrefix(filterType);

            filterValues.forEach((filterObj: FilterValue) => {
              let value: string | undefined;

              if (
                filterType === "Department" ||
                filterType === "tags" ||
                filterType === "internal"
              ) {
                value = filterObj.id;
              } else if (
                filterType === "status" ||
                filterType === "subStatus" ||
                filterType === "priority"
              ) {
                value = filterObj.value;
              } else if (filterType === "member") {
                value = String(filterObj.value);
              } else if (filterType === "Created at") {
                const [startDate, endDate] = (filterObj.value || "")
                  .split(" - ")
                  .map((dateStr) => {
                    const date = parseDate(dateStr);
                    date.setHours(12, 0, 0, 0);
                    return date;
                  });
                params.append("created_from", formatDate(startDate));
                params.append("created_till", formatDate(endDate));
                return;
              } else if (filterType === "Updated at") {
                const [startDate, endDate] = (filterObj.value || "")
                  .split(" - ")
                  .map((dateStr) => {
                    const date = parseDate(dateStr);
                    date.setHours(12, 0, 0, 0);
                    return date;
                  });
                params.append("doc_lastEdit_from", formatDate(startDate));
                params.append("doc_lastEdit_till", formatDate(endDate));
                return;
              }

              if (value !== undefined) {
                params.append(keyPrefix, value.toString());
              }
            });
          }
        });

        if (filters.search) {
          params.append("search", filters.search);
        }
      }

      if (assignedTo) {
        params.append("doc_flag", "archive");
      }

      if (itemStatusDraft) {
        params.append("job_status", "active");
      } else if (itemStatusPending) {
        params.append("job_status", "draft");
      } else if (itemStatusCompleted) {
        params.append("job_status", "close");
        params.append("job_status", "archived");
        params.append("job_status", "deleted");
      }

      const response = await axios.get(url, {
        params: params,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      return response;
    } catch (error) {
      console.error("Error fetching items:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeFilters?.search) {
      // Reset pagination when search filter changes
      setPagination((prev) => ({
        ...prev,
        pageIndex: 0,
        currentPage: 1,
      }));
      // Fetch data for the updated pagination and filters
      fetchItemFeedbackListData(
        0,
        pagination.pageSize,
        activeFilters,
        false,
        itemAssignedTo,
        itemStatusDraft,
        itemStatusPending,
        itemStatusCompleted
      );
    }
  }, [activeFilters?.search]);

  // Helper function to get the key prefix based on filter type
  const getKeyPrefix = (filterType) => {
    switch (filterType) {
      case "Department":
        return "job_department_id";
      case "member":
        return "external";
      case "status":
        return "job_status";
      case "subStatus":
        return "doc_sub_status";
      case "tags":
        return "job_tag";
      case "priority":
        return "item_priority";
      case "internal":
        return "internal";
      case "Created at":
        return "created_from";
      case "Updated at":
        return "doc_lastEdit_from";
      default:
        return filterType.toLowerCase();
    }
  };

  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split(" ");
    const monthIndex = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ].indexOf(month);
    return new Date(year, monthIndex, parseInt(day));
  };

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const fetchItemFeedbackListData = useCallback(
    debounce(
      async (
        pageIndex,
        pageSize,
        filters,
        isInitialFetch = false,
        itemAssignedTo,
        itemStatusDraft,
        itemStatusPending,
        itemStatusCompleted
      ) => {
        if (loadingBarRef.current) {
          loadingBarRef.current.continuousStart();
        }
        setLoading(true);
        try {
          const response = await _get_ItemFeedbackList(
            pageIndex,
            pageSize,
            filters,
            itemAssignedTo,
            itemStatusDraft,
            itemStatusPending,
            itemStatusCompleted
          );

          if (response.status === 200) {
            const newData = response.data.data.jobPost;
            const newPagination = {
              currentPage: response.data.data.currentPage,
              hasNextPage: response.data.data.hasNextPage,
              totalPages: response.data.data.totalPages,
              pageSize: response.data.data.limit,
              pageIndex: response.data.currentPage - 1,
              total: response.data.data.totalJobPost,
            };

            setData(newData);
            setPagination(newPagination);
            setTotalPages(response.data.data.totalPages);
            localStorage.setItem(
              "cachedJobsListData",
              JSON.stringify({
                data: newData,
                pagination: newPagination,
                timestamp: Date.now(),
              })
            );
            if (!isInitialFetch) {
              console.log("Data updated in background");
            }
          }
        } catch (error) {
          console.error("Error fetching item feedback list:", error);
        } finally {
          if (loadingBarRef.current) {
            loadingBarRef.current.complete();
          }
          setLoading(false);
          if (isInitialFetch) {
            setInitialLoading(false);
          }
        }
      },
      500
    ),
    []
  );

  useEffect(() => {
    const handleSidebarItemClick = () => {
      setPagination({
        pageIndex: 0,
        pageSize: 25,
        currentPage: 1,
        hasNextPage: false,
        totalPages: 1,
        total: 0,
      });
      setTotalPages(0);
      fetchItemFeedbackListData(1, 25, true);
    };

    window.addEventListener("paginationresetsetate", handleSidebarItemClick);

    return () => {
      window.removeEventListener(
        "paginationresetsetate",
        handleSidebarItemClick
      );
    };
  }, [fetchItemFeedbackListData]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      const cachedData = localStorage.getItem("cachedJobsListData");
      if (cachedData) {
        setLoading(true);
        const { data: cachedItems, pagination: cachedPagination } =
          JSON.parse(cachedData);
        setData(cachedItems);
        setPagination((prevPagination) => ({
          ...prevPagination,
          ...cachedPagination,
        }));
        setTotalPages(cachedPagination.totalPages);
        setLoading(false);
      } else {
        fetchItemFeedbackListData(
          pagination.currentPage,
          pagination.pageSize,
          activeFilters,
          true,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted
        );
      }
    } else {
      fetchItemFeedbackListData(
        pagination.currentPage,
        pagination.pageSize,
        activeFilters,
        true,
        itemAssignedTo,
        itemStatusDraft,
        itemStatusPending,
        itemStatusCompleted
      );
    }
  }, [
    fetchItemFeedbackListData,
    pagination.currentPage,
    pagination.pageSize,
    activeFilters,
    itemAssignedTo,
    itemStatusDraft,
    itemStatusPending,
    itemStatusCompleted,
  ]);

  const handlePrevPage = () => {
    setLoading(false);
    if (pagination.currentPage > 1) {
      setPagination((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }
  };

  const handleNextPage = () => {
    setLoading(false);
    if (pagination.hasNextPage) {
      setPagination((prev) => ({ ...prev, currentPage: prev.currentPage + 1 }));
    }
  };

  useEffect(() => {
    const handleSidebarItemClick = () => {
      setData([]);
      setPagination({
        pageIndex: 0,
        pageSize: 25,
        currentPage: 1,
        hasNextPage: false,
        totalPages: 1,
        total: 0,
      });
      setTotalPages(0);
      fetchItemFeedbackListData(1, 25, true);
    };

    window.addEventListener("sidebarItemClicked", handleSidebarItemClick);

    return () => {
      window.removeEventListener("sidebarItemClicked", handleSidebarItemClick);
    };
  }, [fetchItemFeedbackListData]);

  const handleSelect = (row: Row<Person>) => {
    setSelectedRows((prevSelectedRows) => {
      const newRowState = { ...prevSelectedRows };
      newRowState[row.id] = !prevSelectedRows[row.id];
      return newRowState;
    });
  };

  const handleTagsSelect = async (tag, id) => {
    setSelectedTags((prev) => ({
      ...prev,
      [id]: tag,
    }));
    setTagsOpen(null);
    setSearchTags((prev) => ({
      ...prev,
      [id]: "",
    }));

    try {
      const payload = {
        id,
        baseId,
        job_tag: String(tag.id),
      };

      const result = await dispatch(updateDocument(payload)).unwrap();

      if (result.status === 200) {
        toast.success("Tags updated successfully");
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false, // assignedTo
         itemStatusDraft,
         itemStatusPending,
          false
        );
        if (updatedResponse.status === 200) {
          const newData = updatedResponse.data.data.jobPost;
          const newPagination = {
            currentPage: updatedResponse.data.data.currentPage,
            hasNextPage: updatedResponse.data.data.hasNextPage,
            totalPages: updatedResponse.data.data.totalJobPost,
            pageSize: updatedResponse.data.data.limit,
            pageIndex: updatedResponse.data.data.currentPage - 1,
            // total: updatedResponse.data.totalInsight,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.data.totalJobPost);

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          console.error(
            "Error fetching updated item feedback list:",
            updatedResponse
          );
          toast.error("Failed to fetch updated item feedback list");
        }
      }
    } catch (error) {
      console.error("Failed to update tag:", error);
      toast.error("Failed to update tag");
    }
  };

  const handleTagsSearch = (e, rowId) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchTags((prev) => ({
      ...prev,
      [rowId]: searchTerm,
    }));
  };

  // Update the filtered tags to use row-specific search
  const getFilteredTags = (rowId) => {
    const searchTerm = searchTags[rowId] || "";
    return (
      tagsList?.data?.filter((tag) => {
        const fullName = `${tag.tag_name || ""}`.toLowerCase();
        return tag.tag_type === "job" && fullName.includes(searchTerm);
      }) || []
    );
  };

  // const filteredTags = tagsList?.data?.filter((tag) => {
  //   const fullName = `${tag.tag_name || ''}`.toLowerCase();
  //   return fullName.includes(searchTags);
  // }) || [];

  const filteredTags =
    tagsList?.data?.filter((tag) => {
      const fullName = `${tag.tag_name || ""}`.toLowerCase();
      return tag.tag_type === "job" && fullName.includes(searchTags);
    }) || [];

  const handleManageRedirect = (rowId) => {
    navigate(`/${baseId}/job/${rowId}/manage/detail`);
  };

  const handleRemoveCache = (id) => {
    localStorage.removeItem("jobActionData");
    localStorage.removeItem("jobByReviewData");
    localStorage.removeItem("jobPipelineStageData");
    localStorage.removeItem("jobPostDetailsData");
    localStorage.removeItem("jobByHiringTeamMembers");
    localStorage.removeItem("activeFiltersJobApplication");
    localStorage.removeItem("activeFiltersJobApplicationKanban");
    localStorage.removeItem("activeFiltersJobReports");
    localStorage.removeItem("cachedJobsDetailsListData");
    localStorage.removeItem("baseScoreCardDataByJob");
    localStorage.removeItem("baseQuestionnaireDataByJob");

    localStorage.removeItem("baseJobListingData");
    localStorage.removeItem("activeFiltersTopics");
    localStorage.removeItem("cachedJobsListData");
    localStorage.removeItem("baseJobScoreCardData");
    localStorage.removeItem("baseScoreCardDataByJob");
    localStorage.removeItem("baseQuestionnaireDataByJob");
    localStorage.removeItem("jobPipelineStageData");
    localStorage.removeItem("activeFiltersJobApplication");
    localStorage.removeItem("activeFiltersJobsListing");
    localStorage.removeItem("activeFiltersJobsDetailsPage");
    localStorage.removeItem("activeFiltersJobApplicationKanban");
    localStorage.removeItem("jobByHiringTeamMembers");
    localStorage.removeItem("jobActionData");
    localStorage.removeItem("jobByReviewData");
    localStorage.removeItem("jobPostDetailsData");
    localStorage.removeItem("JobPipelineDetailsData");
    localStorage.removeItem("activeFiltersBookmark");
    localStorage.removeItem("cachedBookmarkData");
    localStorage.removeItem("forgot_email");
    navigate(`/${baseId}/job/${id}/dashboard`);
  };

  const columns = useMemo<ColumnDef<Person>[]>(
    () => [
      {
        id: "select",
        header: ({ table }) => (
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: (e) => {
                table.getToggleAllRowsSelectedHandler()(e);
                handleCheckboxClick(table);
              },
            }}
          />
        ),
        cell: ({ row }) => (
          <div className="px-1">
            <IndeterminateCheckbox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: (e) => {
                  row.getToggleSelectedHandler()(e);
                  handleCheckboxClick(row, row.original.id);
                },
              }}
            />
          </div>
        ),
      },
      {
        accessor: "job_ref_id",
        header: "ID",
        cell: (info) => {
          const { doc_status, id, job_ref_id } = info.row.original;
          const redirectUrl =
            doc_status === "draft"
              ? `/${baseId}/d/${id}`
              : doc_status === "pending"
              ? `/${baseId}/d/${id}/pending`
              : `/${baseId}/d/${id}/complete`;
          return (
            <Link
              to={`#`}
              className="w-full"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior if needed
                handleRemoveCache(id); // Pass the id to your handler
              }}
            >
              <span className="flex items-center gap-[1rem] text-[13px] text-[#52555a]">
                #{job_ref_id}
              </span>
            </Link>
          );
        },
      },

      {
        accessor: "title",
        header: "Title",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const redirectUrl =
            doc_status === "draft"
              ? `/${baseId}/d/${id}`
              : doc_status === "pending"
              ? `/${baseId}/d/${id}/pending`
              : `/${baseId}/d/${id}/complete`;
          return (
            <Link
              to={`#`}
              className="w-full"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior if needed
                handleRemoveCache(id); // Pass the id to your handler
              }}
            >
              <div className=" relative">
                <div className=" table-tooltip hover:overflow-visible tabletooltip-title">
                  <div className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-2 ">
                    {info?.row?.original?.job_title}
                  </div>
                </div>
              </div>
            </Link>
          );
        },
        sort: (a: { title: string }, b: { title: any }) =>
          a.title.localeCompare(b.title),
      },
      {
        accessor: "tags",
        header: "Tags",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const redirectUrl =
            doc_status === "draft"
              ? `/${baseId}/d/${id}`
              : doc_status === "pending"
              ? `/${baseId}/d/${id}/pending`
              : `/${baseId}/d/${id}/complete`;
          const tagsId = info.row.original.job_tag;
          const tags = tagsList?.data?.find(
            (team) => team.id.toString() == tagsId
          );

          const tagsName = tags ? tags.tag_name : null;
          const tagsColor = tags ? tags.tag_colour : null;

          return (
            <div className="w-full mq1499:ml-[0px] mq3000:ml-[0px]">
              <div className="relative flex justify-start">
                <div className="w-full flex items-center justify-start py-1">
                  <div className="relative">
                    <button
                      type="button"
                      onClick={() =>
                        setTagsOpen((prev) =>
                          prev === info.row.original.id
                            ? null
                            : info.row.original.id
                        )
                      }
                      className="table-tooltip flex items-center max-w-fit font-[500] leading-[1.2]"
                    >
                      {info?.row?.original?.job_tag ? (
                        // Existing tag display
                        <div className="flex items-center max-w-fit font-[500] leading-[1.2] bg-light-gray-100 rounded-full text-[0.75rem] px-[0.5rem] py-[5px] gap-[6px] hover:bg-light-gray-200 transition-colors cursor-pointer">
                          {tagsColor && (
                            <span
                              className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize ${tagsColor}`}
                            ></span>
                          )}
                          <span className="text-[#52555a] font-normal capitalize truncate text-[13px] leading-4 whitespace-nowrap max-w-[150px] w-full overflow-hidden text-ellipsis text-start">
                            {tagsName}
                          </span>
                        </div>
                      ) : (
                        // Add tag or selected tag display
                        <span>
                          {selectedTags[info.row.original.id]?.tag_name ? (
                            <span className="gap-2 truncate flex items-center bg-light-gray-100 rounded-full px-[0.5rem] py-[5px] text-[0.75rem] font-medium text-[#52555a] hover:bg-light-gray-200 transition-colors cursor-pointer">
                              <span
                                className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white ${
                                  selectedTags[info.row.original.id]?.tag_colour
                                }`}
                              ></span>
                              <span className="leading-4 text-ellipsis whitespace-nowrap overflow-hidden text-[#52555a] break-words text-left text-[0.75rem]">
                                {selectedTags[info.row.original.id]?.tag_name}
                              </span>
                            </span>
                          ) : (
                            <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-500 hover:bg-gray-100 transition-colors cursor-pointer">
                              Add Tag
                            </span>
                          )}
                        </span>
                      )}
                    </button>

                    {/* Dropdown - shown for both cases */}
                    {tagsOpen === info.row.original.id && (
                      <>
                        <div
                          className="fixed inset-0 z-[5]"
                          onClick={() => setTagsOpen(null)}
                        ></div>
                        <div className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[198px] min-w-[198px] w-full overflow-hidden rounded-lg border border-border bg-popover p-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                          {/* Search Input */}
                          <div className="p-2 border-b border-gray-200">
                            <input
                              type="text"
                              placeholder="Search tags..."
                              value={searchTags[info.row.original.id] || ""}
                              onChange={(e) =>
                                handleTagsSearch(e, info.row.original.id)
                              }
                              className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                              onClick={(e) => e.stopPropagation()}
                              autoFocus
                            />
                          </div>

                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <div className="max-h-[200px] overflow-auto">
                              {getFilteredTags(info.row.original.id).length >
                              0 ? (
                                getFilteredTags(info.row.original.id).map(
                                  (tag, index) => (
                                    <a
                                      key={index}
                                      href="#"
                                      className="block px-2 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 mx-2 rounded-md"
                                      onClick={() =>
                                        handleTagsSelect(
                                          tag,
                                          info.row.original.id
                                        )
                                      }
                                    >
                                      <div className="flex items-center gap-2">
                                        <span
                                          className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-white capitalize ${tag.tag_colour}`}
                                        ></span>
                                        <span className="text-sm text-gray-700 font-normal leading-4 truncate whitespace-nowrap w-[150px] overflow-hidden text-ellipsis capitalize text-justify">
                                          {tag.tag_name}
                                        </span>
                                      </div>
                                    </a>
                                  )
                                )
                              ) : (
                                <p className="text-gray-500 text-center py-2">
                                  {searchTags[info.row.original.id]
                                    ? "No tags found"
                                    : "No tags found"}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
        sort: (a: { shared: string }, b: { shared: any }) =>
          a.shared.localeCompare(b.shared),
      },
      {
        accessor: "department",
        header: "Department ID",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const redirectUrl =
            doc_status === "draft"
              ? `/${baseId}/d/${id}`
              : doc_status === "pending"
              ? `/${baseId}/d/${id}/pending`
              : `/${baseId}/d/${id}/complete`;

          const channelId = info.row.original.job_department_id;
          const currentChannel = teams?.data?.find(
            (team) => team.id.toString() === channelId
          );

          const channelName = currentChannel
            ? currentChannel.department_name
            : "";
          const channelColor = currentChannel ? currentChannel.color : "gray";

          return (
            <div
              className="relative  mq1499:ml-[0px] mq3000:ml-[0px]"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior if needed
                handleRemoveCache(id); // Pass the id to your handler
              }}
            >
              <Link to={`#`} className="w-full">
                <div className="table-tooltip flex items-center max-w-fit gap-[6px] ">
                  {channelName && (
                    <span
                      className="flex items-center gap-[6px] 
                  text-[13px]  capitalize  rounded-md bg-gray-50 px-2 py-1 
                  text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
                    >
                      {channelName}
                    </span>
                  )}
                </div>
              </Link>
            </div>
          );
        },
        sort: (a: any, b: any) => a.department.localeCompare(b.department),
      },
      // {
      //   accessor: 'status',
      //   header: 'Status',
      //   cell: info => {
      //     const { doc_status, id } = info.row.original;
      //     const redirectUrl = doc_status === 'draft'
      //       ? `/${baseId}/d/${id}`
      //       : doc_status === 'pending'
      //         ? `/${baseId}/d/${id}/pending`
      //         : `/${baseId}/d/${id}/complete`;
      //     const status = info.row.original.doc_status?.trim();
      //     return (
      //       <div className=' relative'>
      //         <Link to={`#`} className='w-full'>
      //           <div className=' table-tooltip flex items-center max-w-fit gap-[6px]'>
      //             {status === 'completed' ? (
      //               <span
      //                 className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 capitalize "
      //               // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
      //               >
      //                 {status}
      //               </span>
      //             ) : status === 'rejected' ? (
      //               <span
      //                 className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
      //               // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
      //               >
      //                 {status}
      //               </span>
      //             ) : status === 'terminated' ? (
      //               <span
      //                 className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10 capitalize"
      //               // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
      //               >
      //                 {status}
      //               </span>
      //             ) : status === 'expired' ? (
      //               <span
      //                 className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
      //               // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
      //               >
      //                 {status}
      //               </span>
      //             ) : status === 'pending' ? (
      //               <span
      //                 className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 capitalize"
      //               >
      //                 {status}
      //               </span>
      //             ) : status === 'draft' ? (
      //               <span
      //                 className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10 capitalize"
      //               >
      //                 {status}
      //               </span>
      //             ) :
      //               null}
      //           </div>
      //         </Link>
      //       </div>

      //     )

      //   },
      //   sort: (a: { status: string }, b: { status: any }) => a.status.localeCompare(b.status),
      // },
      {
        accessor: "applications",
        header: "Applications",
        cell: (info) => {
          const { doc_status, id, inbox, screening, hired, reject } =
            info.row.original;
          return (
            <Link
              to={`#`}
              className="w-full relative flex justify-start  mq1499:ml-[0px] mq3000:ml-[0px]"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior if needed
                handleRemoveCache(id); // Pass the id to your handler
              }}
            >
              <div className="flex items-center ml-[0px]">
                <button
                  data-title={"Inbox"}
                  className=" table-tooltip-list before:!bottom-[18px] before:!left-[11px] before:!text-[11px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2]  py-[5px]
         border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md bg-gray-50 font-medium text-[#0000007a] "
                >
                  {inbox}
                </button>
                <button
                  data-title={"Screening"}
                  className="table-tooltip-list before:!bottom-[18px] before:!left-[11px] before:!text-[11px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-medium py-[5px] 
              border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  bg-blue-50 text-[#0000007a]"
                >
                  {screening}
                </button>
                <button
                  data-title={"Hired"}
                  className="table-tooltip-list before:!bottom-[18px] before:!left-[11px] before:!text-[11px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-medium py-[5px] 
              border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  bg-green-50 text-[#0000007a]"
                >
                  {hired}
                </button>
                <button
                  data-title={"Reject"}
                  className="table-tooltip-list before:!bottom-[18px] before:!left-[11px] before:!text-[11px] px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-medium py-[5px] border
         border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md bg-red-50 text-[#0000007a] "
                >
                  {reject}
                </button>
              </div>
            </Link>
          );
        },
        sort: (a: { applications: string }, b: { applications: string }) =>
          new Date(a.applications).getTime() -
          new Date(b.applications).getTime(),
      },
      {
        accessor: "activity",
        header: "Activity",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const redirectUrl =
            doc_status === "draft"
              ? `/${baseId}/d/${id}`
              : doc_status === "pending"
              ? `/${baseId}/d/${id}/pending`
              : `/${baseId}/d/${id}/complete`;
          const formattedDate = format(
            new Date(info.row.original.updated_at),
            "MMM d"
          );
          // const formattedDatetooltip = format(new Date(info.row.original.doc_createdat), 'MMM d');

          const formattedDatetooltip = info.row.original?.updated_at
            ? format(
                new Date(info.row.original.updated_at),
                "d MMMM yyyy, h:mm a"
              )
            : "";

          return (
            <Link
              to={`#`}
              className="w-full relative flex justify-start  mq1499:ml-[0px] mq3000:ml-[0px]"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior if needed
                handleRemoveCache(id); // Pass the id to your handler
              }}
            >
              <div
                data-title={formattedDatetooltip}
                className="table-tooltip-list before:!bottom-[18px] before:!left-[11px] text-[#52555a] font-normal  text-[13px] leading-4  text-start"
              >
                {formattedDate}
              </div>
            </Link>
          );
        },
        sort: (a: { updated_at: string }, b: { updated_at: string }) =>
          new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime(),
      },
      {
        accessor: "status",
        header: "Status",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const redirectUrl =
            doc_status === "draft"
              ? `/${baseId}/d/${id}`
              : doc_status === "pending"
              ? `/${baseId}/d/${id}/pending`
              : `/${baseId}/d/${id}/complete`;
          const status = info.row.original.job_status?.trim();

          return (
            <div
              className=" relative   mq1499:ml-[0px] mq3000:ml-[0px]"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior if needed
                handleRemoveCache(id); // Pass the id to your handler
              }}
            >
              <Link to={`#`} className="w-full">
                <div className=" table-tooltip flex items-center max-w-fit gap-[6px]">
                  {status === "active" ? (
                    <span
                      className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 capitalize "
                      // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                    >
                      {status}
                    </span>
                  ) : status === "archived" ? (
                    <span
                      className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 capitalize"
                      // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                    >
                      {status}
                    </span>
                  ) : status === "close" ? (
                    <span
                      className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                      // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                    >
                      {status}
                    </span>
                  ) : status === "deleted" ? (
                    <span
                      className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                      // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                    >
                      {status}
                    </span>
                  ) : status === "draft" ? (
                    <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10 capitalize">
                      {status}
                      {/* completed-payment */}
                    </span>
                  ) : null}
                </div>
              </Link>
            </div>
          );
        },
        sort: (a: { status: string }, b: { status: any }) =>
          a.status.localeCompare(b.status),
      },
      // {
      //   accessor: 'members',
      //   header: 'Members',
      //   cell: info => {
      //     const { doc_status, id } = info.row.original;
      //     const ItemMemberInternal = info.row.original.item_members.internal;
      //     const ItemMemberExternal = info.row.original.item_members.external;
      //     const redirectUrl = doc_status === 'draft'
      //       ? `/${baseId}/d/${id}`
      //       : doc_status === 'pending'
      //         ? `/${baseId}/d/${id}/pending`
      //         : `/${baseId}/d/${id}/complete`;

      //     return (
      //       <Link to={`#`} className='w-full  mq1499:ml-[0px] mq3000:ml-[0px]'>
      //         <div className=' relative '>
      //           <div className='flex items-center gap-x-[100px]'>
      //             <div className='flex items-center gap-x-2'>
      //               <div className="isolate flex -space-x-1 relative">
      //                 {ItemMemberInternal.length > 0 &&
      //                   ItemMemberInternal.map((memberData, index) => (
      //                     <>
      //                       {memberData?.profile_pic ? (
      //                         <div key={memberData.id || index} className="w-[22px] h-[22px] relative">
      //                           <div className='table-tooltip-list before:!bottom-[18px] before:!left-[11px]' data-title={memberData?.contact_first_name}>
      //                             <img
      //                               src={`${process.env.REACT_APP_API_BASE_URL}/${memberData.profile_pic}`}
      //                               alt={memberData?.contact_first_name || 'Member Profile'}
      //                               className="w-[22px] h-[22px] rounded-full ring-2 ring-white bg-gray-300 flex items-center justify-center text-[11px] font-[500] text-[#52555a]"
      //                             />
      //                           </div>
      //                         </div>
      //                       ) : (
      //                         memberData?.contact_first_name && (
      //                           <div
      //                             data-title={memberData?.contact_first_name}
      //                             className="table-tooltip before:!bottom-[-2px] before:!left-[-27px] size-6 rounded-full ring-2 ring-white bg-gray-300 flex items-center justify-center text-[11px] font-[500] text-[#52555a]"
      //                           >
      //                             {memberData?.contact_first_name.charAt(0).toUpperCase()}
      //                           </div>
      //                         )
      //                       )}
      //                     </>
      //                   ))}
      //               </div>

      //               {ItemMemberInternal.some((memberData) => memberData?.contact_first_name) > 0 &&
      //                 ItemMemberExternal.some((memberData) => memberData?.contact_first_name) && (
      //                   <div className='w-[1px] h-[12px] bg-[#00000050]'></div>
      //                 )}

      //               <div className="isolate flex -space-x-1 relative">
      //                 {ItemMemberExternal.length > 0 &&
      //                   ItemMemberExternal.map((memberData, index) => {
      //                     return (
      //                       <div key={index}>
      //                         {memberData.profile_pic ? (
      //                           <div className="table-tooltip before:!bottom-[-2px] before:!left-[-66px]" data-title={memberData.contact_first_name || memberData.contact_email || 'External Member'}>
      //                             <img
      //                               src={`${process.env.REACT_APP_API_BASE_URL}/${memberData.profile_pic}`}
      //                               alt={
      //                                 memberData.contact_first_name || memberData.contact_first_name || 'External Member'
      //                               }
      //                               className="relative z-30 inline-block  w-[22px] h-[22px]  rounded-full ring-2 ring-white object-cover"
      //                             />
      //                           </div>
      //                         ) : (
      //                           <>
      //                             {
      //                               memberData.contact_first_name || memberData.contact_email ? (
      //                                 <div
      //                                   data-title={memberData.contact_first_name || memberData.contact_email}
      //                                   className="table-tooltip-list before:!bottom-[18px] before:!left-[11px]  w-[22px] h-[22px]  rounded-full ring-2 ring-white bg-gray-300 flex items-center justify-center text-[11px] font-[500] text-[#52555a]"
      //                                 >
      //                                   {(memberData.contact_first_name
      //                                     ? memberData.contact_first_name.charAt(0).toUpperCase()
      //                                     : memberData.contact_email.charAt(0).toUpperCase())
      //                                   }
      //                                 </div>
      //                               ) : null
      //                             }
      //                           </>
      //                         )}
      //                       </div>
      //                     );
      //                   })}
      //               </div>
      //             </div>
      //             <div>
      //             </div>
      //           </div>
      //           {/*
      //           <div className="flex items-center gap-x-4">
      //             <div className="isolate flex -space-x-1 relative">
      //               <div className="w-[18px] h-[18px] relative ">
      //                 <div
      //                   className="table-tooltip-list before:!bottom-[18px] before:!left-[11px]"
      //                   data-title="Vikas Kumar"
      //                 >
      //                   <img
      //                     src="https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/uploads/userProfile/9fc5400e-4ae6-410e-8d0b-87a12adbc08c.png"
      //                     alt="Vikas Kumar"
      //                     className=" w-[18px] h-[18px] rounded-full ring-2 ring-white bg-gray-300 flex items-center justify-center text-[11px] font-[500] text-[#52555a]"
      //                   />
      //                 </div>
      //               </div>
      //               <div className="w-[18px] h-[18px] relative ">
      //                 <div
      //                   className="table-tooltip-list before:!bottom-[18px] before:!left-[11px]"
      //                   data-title="shruti"
      //                 >
      //                   <img
      //                     src="https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/uploads/userProfile/672a8900-9bcd-45c8-8a11-ea7b3fb085fd.png"
      //                     alt="shruti"
      //                     className="w-[18px] h-[18px] rounded-full ring-2 ring-white bg-gray-300 flex items-center justify-center text-[11px] font-[500] text-[#52555a]"
      //                   />
      //                 </div>
      //               </div>
      //             </div>
      //             <div className='w-[1px] h-[12px] bg-[#00000050]'></div>
      //             <div className="isolate flex -space-x-1 relative">
      //               <div className="w-[18px] h-[18px] relative ">
      //                 <div
      //                   className="table-tooltip-list before:!bottom-[18px] before:!left-[11px]"
      //                   data-title="Vikas Kumar"
      //                 >
      //                   <img
      //                     src="https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/uploads/userProfile/9fc5400e-4ae6-410e-8d0b-87a12adbc08c.png"
      //                     alt="Vikas Kumar"
      //                     className="w-[18px] h-[18px] rounded-full ring-2 ring-white bg-gray-300 flex items-center justify-center text-[11px] font-[500] text-[#52555a]"
      //                   />
      //                 </div>
      //               </div>
      //               <div className="w-[18px] h-[18px] relative ">
      //                 <div
      //                   className="table-tooltip-list before:!bottom-[18px] before:!left-[11px]"
      //                   data-title="shruti"
      //                 >
      //                   <img
      //                     src="https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/uploads/userProfile/672a8900-9bcd-45c8-8a11-ea7b3fb085fd.png"
      //                     alt="shruti"
      //                     className="w-[18px] h-[18px] rounded-full ring-2 ring-white bg-gray-300 flex items-center justify-center text-[11px] font-[500] text-[#52555a]"
      //                   />
      //                 </div>
      //               </div>
      //             </div>

      //           </div> */}

      //           {/* <div className='table-tooltip flex items-center max-w-fit inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10'>
      //             test12@gmail.com

      //           </div> */}
      //         </div>
      //       </Link>
      //     );
      //   },
      //   sort: (a: { members: string }, b: { members: any }) => a.members.localeCompare(b.members),
      // }
    ],
    [
      teams,
      tagsList?.data,
      tagsList,
      baseId,
      tagsOpen,
      searchTags,
      selectedTags,
      filteredTags,
    ]
  );

  // teams
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseDepartmentData");
        if (storedBase) {
          setTeams(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(
              fetchDepartmentList(userDetails?.id || baseId)
            );
            setTeams(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    setSelectedRowsCount(Object.keys(rowSelection)?.length);
  }, [rowSelection]);

  const handleCheckboxClick = (row, id) => {
    setSelectedRows((prevSelectedRows) => ({
      ...prevSelectedRows,
      [row.id]: !prevSelectedRows[row.id],
    }));
    setRowSelectionDelete((prevSelection) => {
      if (prevSelection?.includes(id)) {
        return prevSelection.filter((itemId) => itemId !== id);
      } else {
        return [...prevSelection, id];
      }
    });

    setIsModalOpenCheckbox(true);
  };

  const handleConfirmDelete = (id) => {
    setDeleteOk(true);
  };

  const handleAddTags = (id) => {
    setAddTags(true);
  };

  const handleDeleteConfirm = async () => {
    setDeleteLoading(true);
    try {
      let groupIdsToDelete = Array.isArray(rowSelectionDelete)
        ? rowSelectionDelete
        : [rowSelectionDelete];

      const deleteResponse = await dispatch(
        deleteItemFeedback(baseId, groupIdsToDelete)
      );

      if (!deleteResponse || !deleteResponse.data) {
        throw new Error("Invalid delete response received");
      }

      // Process the delete response
      const successfulDeletes = deleteResponse.data
        .filter((item) => item.isSuccess)
        .map((item) => item.id);
      const failedDeletes = deleteResponse.data.filter(
        (item) => !item.isSuccess
      );

      if (successfulDeletes.length > 0) {
        toast.success(`Successfully deleted item(s)`);
      }
      // successfulDeletes.forEach((id) => {
      //   toast.success(`Successfully deleted item ${id}`);
      // });
      failedDeletes.forEach((item) => {
        toast.error(`Failed to delete item ${item.id}: ${item.reason}`);
      });

      if (successfulDeletes.length > 0) {
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted
        );

        if (updatedResponse.status === 200) {
          const newData = updatedResponse.data.items;
          const newPagination = {
            currentPage: updatedResponse.data.currentPage,
            hasNextPage: updatedResponse.data.hasNextPage,
            totalPages: updatedResponse.data.totalPages,
            pageSize: updatedResponse.data.pageSize,
            pageIndex: updatedResponse.data.currentPage - 1,
            // total: updatedResponse.data.totalInsight,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.totalPages);

          // Update local storage with new data
          localStorage.setItem(
            "cachedJobsListData",
            JSON.stringify({
              data: newData,
              pagination: newPagination,
              timestamp: Date.now(),
            })
          );

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          console.error(
            "Error fetching updated item feedback list:",
            updatedResponse
          );
          toast.error("Failed to fetch updated item feedback list");
        }
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`An error occurred: ${error.response.data.message}`);
      } else {
        console.error("Error deleting insight groups:", error);
        toast.error(
          "An error occurred while deleting insight groups. Please try again later."
        );
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDeleteSingleRow = async (rowId?: string) => {
    setDeleteLoading(true);
    try {
      let idsToDelete: string[];

      if (rowId) {
        // Single row deletion
        idsToDelete = [rowId];
      }

      const deleteResponse = await dispatch(
        deleteItemFeedback(baseId, idsToDelete)
      );

      if (!deleteResponse || !deleteResponse.data) {
        throw new Error("Invalid delete response received");
      }

      // Process the delete response
      const successfulDeletes = deleteResponse.data
        .filter((item) => item.isSuccess)
        .map((item) => item.id);
      const failedDeletes = deleteResponse.data.filter(
        (item) => !item.isSuccess
      );

      if (successfulDeletes.length > 0) {
        toast.success(`Successfully deleted item(s)`);
      }
      // successfulDeletes.forEach((id) => {
      //   toast.success(`Successfully deleted item ${id}`);
      // });
      failedDeletes.forEach((item) => {
        toast.error(`Failed to delete item ${item.id}: ${item.reason}`);
      });

      if (successfulDeletes.length > 0) {
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted
        );

        if (updatedResponse.status === 200) {
          const newData = updatedResponse.data.items;
          const newPagination = {
            currentPage: updatedResponse.data.currentPage,
            hasNextPage: updatedResponse.data.hasNextPage,
            totalPages: updatedResponse.data.totalPages,
            pageSize: updatedResponse.data.pageSize,
            pageIndex: updatedResponse.data.currentPage - 1,
            // total: updatedResponse.data.totalInsight,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.totalPages);

          // Update local storage with new data
          localStorage.setItem(
            "cachedJobsListData",
            JSON.stringify({
              data: newData,
              pagination: newPagination,
              timestamp: Date.now(),
            })
          );

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          toast.error("Failed to fetch updated item feedback list");
        }
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`An error occurred: ${error.response.data.message}`);
      } else {
        toast.error(
          "An error occurred while deleting insight groups. Please try again later."
        );
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  const table = useReactTable({
    data,
    columns,
    state: {
      pagination,
      rowSelection,
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    debugTable: true,
    onPaginationChange: setPagination,
  });

  useEffect(() => {
    const applyStyles = () => {
      const tableElement = document.querySelector(
        ".feedback-col"
      ) as HTMLElement | null;
      const tableElement1 = document.querySelector(
        ".feedback-thead"
      ) as HTMLElement | null;
      const isTabScreen = window.matchMedia("(max-width: 1499px)").matches;
      const isSmallScreen = window.matchMedia("(max-width: 767px)").matches;
      const hasSearchFilter = !!activeFilters?.search;

      // Apply margin-top to tableElement based on screen size
      if (tableElement) {
        if (isSmallScreen) {
          tableElement.style.paddingTop = sectionHeight
            ? `calc(50px + ${sectionHeight}px)`
            : "50px";
        } else if (isTabScreen) {
          tableElement.style.paddingTop = sectionHeight
            ? `calc(5px + ${sectionHeight}px)`
            : "45px";
        } else {
          tableElement.style.paddingTop = sectionHeight
            ? `calc(89px + ${sectionHeight}px)`
            : "89px";
        }
      }

      // Apply top style to tableElement1 based on screen size and search filter
      if (tableElement1) {
        if (isSmallScreen) {
          tableElement1.style.top = sectionHeight
            ? `calc(80px + ${sectionHeight}px)`
            : "80px";
        } else if (isTabScreen) {
          tableElement1.style.top = sectionHeight
            ? `calc(101px + ${sectionHeight}px)`
            : "101px";
        } else {
          tableElement1.style.top = sectionHeight
            ? `calc(101px + ${sectionHeight}px)`
            : "99px";
        }

        if (sectionHeight) {
          tableElement1.style.top = sectionHeight
            ? `calc(101px + ${sectionHeight}px)`
            : "99px";
          tableElement1.style.borderTop = "1px solid #e5e7eb";
        } else {
          tableElement1.style.borderTop = "none";
        }
      }
    };

    applyStyles();

    window.addEventListener("resize", applyStyles);
    return () => {
      window.removeEventListener("resize", applyStyles);
    };
  }, [sectionHeight]);

  // tags

  // useEffect(() => {
  //   if (baseId) {
  //     const fetchTeams = async () => {
  //       const storedBase = localStorage.getItem('baseTagsData');
  //       if (storedBase) {
  //         setTagsList(JSON.parse(storedBase));
  //         setRoleList(JSON.parse(storedBase).data); // Ensure the dropdown gets the list
  //         setSelectRole(JSON.parse(storedBase).data[0] || "");
  //       } else {
  //         try {
  //           const baseResponse = await dispatch(fetchTagsDataList({ baseId: userDetails?.id || Number(baseId) }));
  //           setTagsList(baseResponse.payload.data);
  //           setRoleList(baseResponse.payload.data);
  //           setSelectRole(baseResponse.payload.data[0]?.tag_name || "");
  //         } catch (error) {
  //           console.error("Error fetching base member details:", error);
  //         }
  //       }
  //     };
  //     fetchTeams();
  //   }
  // }, [baseId, dispatch]);

  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseTagsData");
        if (storedBase) {
          const parsedData = JSON.parse(storedBase);
          const jobTags =
            parsedData.data?.filter((tag) => tag.tag_type === "job") || [];

          setTagsList({ ...parsedData, data: jobTags });
          setRoleList(jobTags); // Ensure the dropdown gets the filtered list
          setSelectRole(jobTags[0] || "");
        } else {
          try {
            const baseResponse = await dispatch(
              fetchPipelineStagesList({ baseId: Number(baseId) })
            );
            const jobTags =
              baseResponse.payload.data?.filter(
                (tag) => tag.tag_type === "job"
              ) || [];

            setTagsList({ ...baseResponse.payload, data: jobTags });
            setRoleList(jobTags);
            setSelectRole(jobTags[0]?.tag_name || "");
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  const addTagsToDocument = async () => {
    try {
      // Get selected document IDs from rowSelection state
      const selectedDocIds = Object.keys(rowSelection).map((index) => {
        return data[parseInt(index)].id.toString();
      });

      if (selectedDocIds.length === 0) {
        console.error("No documents selected");
        return;
      }

      const selectedTagId = selectRole.id.toString();

      const payload = {
        baseId: baseId,
        job_tag: selectedTagId,
        doc_ids: selectedDocIds,
      };

      setDeleteLoading(true);

      // Dispatch the updateTags action
      const response = await dispatch(updateTags(payload)).unwrap();

      if (response.status === 200) {
        setData((prevData) => {
          return prevData.map((doc) => {
            if (selectedDocIds.includes(doc.id.toString())) {
              return {
                ...doc,
                doc_tag: selectedTagId,
                tag_name: selectRole.tag_name,
                tag_colour: selectRole.tag_colour,
              };
            }
            return doc;
          });
        });

        setAddTags(false);
        setRowSelection({});

        const updatedCache = {
          data: data.map((doc) => {
            if (selectedDocIds.includes(doc.id.toString())) {
              return {
                ...doc,
                doc_tag: selectedTagId,
                tag_name: selectRole.tag_name,
                tag_colour: selectRole.tag_colour,
              };
            }
            return doc;
          }),
          pagination: pagination,
          timestamp: Date.now(),
        };
        localStorage.setItem(
          "cachedJobsListData",
          JSON.stringify(updatedCache)
        );
        toast.success("Tags updated successfully");
      }
    } catch (error) {
      console.error("Failed to update tags:", error);
      toast.error("Failed to update tags");
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <>
      <LoadingBar color="#ff591e" ref={loadingBarRef} />
      <div className="mx-auto max-w-full">
        <div className="px-4 sm:px-6 lg:px-8 feedback-table">
          <div className="flow-root h-full">
            <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8 h-full">
              <div className="inline-block min-w-full py-2 align-middle h-full max-w-full">
                <div className="relative  h-full pb-[0rem]">
                  <table
                    className="block border-collapse overflow-x-auto w-full feedback-col overflow-y-auto feedback-table-height h-full"
                    style={{
                      borderRight: "1px solid #e0e0e0a1",
                    }}
                  >
                    <thead
                      className="mq1499:sticky mq3000:fixed bg-white feedback-thead feedback-table-row"
                      style={{
                        width: verticleSidebar
                          ? "calc(100% - 242px)"
                          : "calc(100% - 69px)",
                        zIndex: verticleSidebar ? 2 : 2,
                        // borderRight: '1px solid #e0e0e0a1'
                      }}
                    >
                      {table.getHeaderGroups().map((headerGroup) => (
                        <tr
                          key={headerGroup.id}
                          className=" flex relative w-full border-b  border-solid border-light-gray-200"
                        >
                          {headerGroup.headers.map((header) => {
                            return (
                              <th
                                key={header.id}
                                colSpan={header.colSpan}
                                scope="col"
                                className={`sticky bg-white flex flex-1 py-[0.75rem] px-[1rem] cursor-pointer text-[0.75rem] items-center justify-start
                                   leading-[1rem] text-[#52555a] font-[500] min-w-[50px] md:min-w-[160px] lg:min-w-[50px]
                                  ${
                                    header.id === "select"
                                      ? "max-w-[50px] [&>div]:px-0 mq1300:!min-w-[50px]"
                                      : ""
                                  } 
                                  ${
                                    header.id === "ID"
                                      ? "mq1800:max-w-[60px] mq3000:max-w-[60px] mq1800:!min-w-[60px] mq3000:!min-w-[60px] !pl-[0.1rem] !pr-[0.4rem]"
                                      : ""
                                  }
                                  ${
                                    header.id === "Title"
                                      ? `mq1800:max-w-[300px] mq1800:!min-w-[300px] !px-[0.8rem] ${
                                          verticleSidebar
                                            ? "mq3000:max-w-[300px] mq3000:min-w-[320px]"
                                            : " mq3000:max-w-[320px] mq3000:min-w-[320px]"
                                        }`
                                      : ""
                                  }
                                  ${
                                    header.id === "Tags"
                                      ? "mq1800:!min-w-[220px] mq1800:max-w-[220px] mq3000:max-w-[220px] mq3000:!min-w-[220px]"
                                      : ""
                                  } 
                                  ${
                                    header.id === "Department ID"
                                      ? "mq1800:!min-w-[230px] mq1800:max-w-[230px]  mq3000:!max-w-[250px] mq3000:!min-w-[180px]"
                                      : ""
                                  }
                                  ${
                                    header.id === "Applications"
                                      ? "mq1800:!min-w-[200px] mq1800:!max-w-[200px] mq3000:!max-w-[250px] mq3000:!min-w-[200px]"
                                      : ""
                                  }
                                  ${
                                    header.id === "Activity"
                                      ? "mq1800:!min-w-[200px] mq1800:!max-w-[200px] mq3000:!max-w-[250px] mq3000:!min-w-[180px]"
                                      : ""
                                  }
                                  ${
                                    header.id === "Status"
                                      ? "mq1800:!min-w-[320px] mq1800:max-w-[550px] mq3000:!min-w-[300px] mq3000:max-w-[680px]"
                                      : ""
                                  }`}
                              >
                                <div
                                  {...{
                                    className: header.column.getCanSort()
                                      ? "cursor-pointer select-none "
                                      : "",
                                    onClick:
                                      header.column.getToggleSortingHandler(),
                                  }}
                                >
                                  {flexRender(
                                    header.column.columnDef.header,
                                    header.getContext()
                                  )}
                                  {{
                                    asc: " 🔼",
                                    desc: " 🔽",
                                  }[header.column.getIsSorted() as string] ??
                                    null}
                                </div>
                              </th>
                            );
                          })}
                          <th
                            className={`sticky bg-white flex flex-1 py-[0.75rem] px-[1rem] cursor-pointer text-[0.75rem] items-center justify-start
                             leading-[1rem] text-[#52555a] font-[500]  min-w-[70px] max-w-[56px]`}
                          ></th>
                        </tr>
                      ))}
                    </thead>

                    <tbody
                      className="grid mt-[0px] relative"
                      style={{ zIndex: 1 }}
                    >
                      {table.getRowModel().rows.length === 0 ? (
                        <tr className="w-full">
                          {/* <td colSpan={columns.length} className="w-full border-b border-light-gray-200"> */}
                          <div
                            className="w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3"
                            style={{ height: "calc(100vh - 280px)" }}
                          >
                            <ExclamationIcon />
                            <p className="text-[#0000007a] text-[13px]">
                              No results found
                            </p>
                          </div>
                          {/* </td> */}
                        </tr>
                      ) : (
                        table.getRowModel().rows.map((row) => {
                          const allRowsSelected = table.getIsAllRowsSelected();
                          const dropdownGroups: DropdownGroup[] = [
                            {
                              options: [
                                {
                                  label: `Delete`,
                                  className:
                                    "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                                  onClick: () =>
                                    handleDeleteSingleRow(row.original.id),
                                },
                                {
                                  label: `Archive`,
                                  className:
                                    "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                                  // onClick: () => handleDeleteSingleRow(row.original.id),
                                },
                                {
                                  label: `Manage`,
                                  className:
                                    "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                                  onClick: () =>
                                    handleManageRedirect(row.original.id),
                                },
                              ],
                            },
                          ];
                          return (
                            <tr
                              key={row.id}
                              data-selected={
                                allRowsSelected ? true : selectedRows[row.id]
                              }
                              // onClick={() => handleSelect(row)}
                              className={`border-b border-solid border-light-gray-200 bg-white flex w-full relative 
                                  ${selectedRows[row.id] ? "bg-gray-100" : ""} 
                                  ${customVerticalSidebar ? "-z-[1]" : ""}
                                    ${isTooltipHovered ? "z-[-1]" : ""}
                                  `}
                              // ${customVerticalSidebar ? '-z-[1]' : 'z-[2]'} // need comment
                            >
                              {row.getVisibleCells().map((cell) => (
                                <td
                                  key={cell.id}
                                  className={`flex items-center justify-start text-start px-[1rem] py-[0.9rem] leading-[1rem]
                                         flex-1 text-dark-black-200 max-w-[350px]
                                         ${
                                           /(_select)$/.test(cell.id)
                                             ? "max-w-[50px] [&>div]:px-0"
                                             : ""
                                         } 
                                         ${
                                           /(_ID)$/.test(cell.id)
                                             ? "mq1800:min-w-[60px] mq1800:max-w-[60px] mq3000:max-w-[60px] mq3000:min-w-[60px] !pl-[0.1rem] !pr-[0.4rem]"
                                             : ""
                                         }
                                         ${
                                           /(_Title)$/.test(cell.id)
                                             ? "mq1800:!max-w-[300px] mq1800:!min-w-[300px] mq3000:max-w-[300px] mq3000:!min-w-[320px] !px-[0.8rem]"
                                             : ""
                                         }
                                         ${
                                           /(_Department ID)$/.test(cell.id)
                                             ? "mq1800:!min-w-[230px] mq1800:!max-w-[230px] mq3000:!max-w-[250px] mq3000:!min-w-[180px]"
                                             : ""
                                         }
                                         ${
                                           /(_Tags)$/.test(cell.id)
                                             ? "mq1800:!min-w-[220px] mq1800:!max-w-[220px] mq3000:!max-w-[220px] mq3000:!min-w-[220px]"
                                             : ""
                                         }
                                          ${
                                            /(_Applications)$/.test(cell.id)
                                              ? "mq1800:!min-w-[200px] mq1800:!max-w-[200px] mq3000:!max-w-[250px] mq3000:!min-w-[200px]"
                                              : ""
                                          }
                                         ${
                                           /(_Activity)$/.test(cell.id)
                                             ? "mq1800:!min-w-[200px] mq1800:!max-w-[200px] mq3000:!max-w-[250px] mq3000:!min-w-[180px]"
                                             : ""
                                         }
                                         ${
                                           /(_Status)$/.test(cell.id)
                                             ? "mq1800:!min-w-[320px] mq1800:!max-w-[550px] mq3000:!min-w-[300px] mq3000:max-w-[680px]"
                                             : ""
                                         }
                                       `}
                                >
                                  {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                  )}
                                </td>
                              ))}
                              <td
                                className={`flex items-center text-start px-[0.75rem] py-[1rem] leading-[1rem] flex-1 
                                   min-w-[70px] max-w-[56px] text-dark-black-200 justify-center [&>button]:w-auto [&>button]:bg-transparent [&>button]:hover:bg-transparent`}
                              >
                                <CustomMenuDropdown
                                  sections={dropdownGroups}
                                  icon={
                                    <svg
                                      stroke="currentColor"
                                      fill="none"
                                      strokeWidth="2"
                                      viewBox="0 0 24 24"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      aria-hidden="true"
                                      focusable="false"
                                      height="1em"
                                      width="1em"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle cx="12" cy="12" r="1"></circle>
                                      <circle cx="12" cy="5" r="1"></circle>
                                      <circle cx="12" cy="19" r="1"></circle>
                                    </svg>
                                  }
                                  menuItemsClassName="left-auto"
                                />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="fixed bg-white  py-[0.5rem] px-[1rem] bottom-[7px] rounded-br-lg"
        style={{
          width: verticleSidebar ? `calc(100% - 241px${isChatOpen ? ' - 511px' : ''})`: "calc(100% - 68px)",
          zIndex: customVerticalSidebar ? [-2] : 2,
          borderBottom: "1px solid rgba(224, 224, 224, 0.63)",
          borderTop: "1px solid rgba(224, 224, 224, 0.63)",
          borderRight: "1px solid rgba(224, 224, 224, 0.63)",
        }}
      >
        <div className="relative flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-1">
              <div className="text-[0.875rem] font-[500] text-[#000000eb]">
                Page
              </div>
            </span>
            <span className="flex items-center gap-1">
              <input
                type="number"
                value={pagination.currentPage}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) : 1;
                  setPagination((prevPagination) => ({
                    ...prevPagination,
                    currentPage: page,
                  }));
                }}
                className="w-[4rem] h-[2rem] text-[0.8125rem] px-[0.75rem] rounded-md border border-gray-200 focus:outline-none"
              />
              <span className="mr-1 text-[#000000eb] text-[0.8125rem]">
                {" "}
                of {totalPages}
              </span>
            </span>

            <div className="flex items-center gap-1">
              <select
                value={table.getState().pagination.pageSize}
                onChange={(e) => {
                  table.setPageSize(Number(e.target.value));
                }}
                className="w-[6rem] h-[2rem] text-[0.8125rem] px-[0.75rem] rounded-md border border-gray-200 focus:outline-none"
              >
                {[25, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
              <div className="mr-1 text-[#000000eb] text-[0.8125rem] ml-[14px]">
                {pagination.total} Items
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              className="border rounded py-2 px-2"
              onClick={handlePrevPage}
              disabled={pagination.currentPage === 1}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-2 w-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                />
              </svg>
            </button>
            <button
              className="border rounded py-2 px-2"
              onClick={handleNextPage}
              disabled={!pagination.hasNextPage}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-2 w-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* <div open={isModalOpenCheckbox} onClose={() => { }} className={`relative z-10 w-full ${isModalOpenCheckbox ? 'common-slider-one' : 'common-slider-two'}`}
      >
        {selectedRowsCount > 0 && (
          <div className="fixed inset-y-0 right-0 flex checkbox-modal-list h-[80px] w-[800px] max-w-[800px] bottom-0 top-[-70px]">
            <div className="flex h-auto flex-col overflow-y-scroll bg-white py-6 rounded-lg w-full"
              style={{ boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1),0 2px 4px -1px rgba(0, 0, 0, 0.06)' }}>
              <div className="px-4 sm:px-6">
                <div className="flex items-center justify-between">
                  <span className='text-dark-black-100 text-[13px] font-[700]'>{selectedRowsCount} selected</span>
                  <div className="flex items-center">
                    <div className="w-full flex items-center justify-between">
                      <div className="flex items-center gap-[0.5rem]">
                        <button
                          className='group inline-flex shrink-0 select-none items-center justify-center transition-colors
                         duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                          disabled:pointer-events-none gap-1 px-[12px] dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50
                           dark:border-surface-100 py-[8px] outline-primary disabled:text-surface-300 text-[13px]
                         text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none'
                          onClick={(id) => handleAddTags(id)}
                        >


                          Add tags
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-tag w-[0.8rem] h-[0.8rem] text-[#808080] mr-[4px]"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z" />
                          </svg>


                        </button>
                        <button
                          // onClick={(id) => handleConfirmDelete(id)}
                          className='group inline-flex shrink-0 select-none items-center justify-center transition-colors
                          duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                           disabled:pointer-events-none gap-1 px-[12px] dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50
                            dark:border-surface-100 py-[8px] outline-primary disabled:text-surface-300 text-[13px]
                          text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none'
                        >
                          Delete
                          <DeleteIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        )}
      </div> */}

      {/* add tags */}

      <Dialog open={addTags} onClose={setAddTags} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setAddTags(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Do you want to add tags to the selected items?
                </DialogTitle>
                <Listbox value={selectRole} onChange={setSelectRole}>
                  <div className="relative mt-5">
                    <ListboxButton className="flex items-center justify-between w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                      <span className="col-start-1 row-start-1 truncate pr-6 capitalize">
                        {selectRole.tag_name}
                      </span>
                      <ChevronDownIcon
                        aria-hidden="true"
                        className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                      />
                    </ListboxButton>

                    <ListboxOptions
                      transition
                      className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                    >
                      {roleList.map((person) => (
                        <ListboxOption
                          key={person.id}
                          value={person}
                          className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                        >
                          <span className="block truncate font-normal group-data-[selected]:font-semibold capitalize">
                            {person.tag_name}
                          </span>

                          <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white"></span>
                        </ListboxOption>
                      ))}
                    </ListboxOptions>
                  </div>
                </Listbox>
              </div>
              <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                <button
                  type="button"
                  // onClick={handleDeleteConfirm}
                  className="flex w-fit justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold 
                leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 
                focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={addTagsToDocument}
                >
                  Add Tags
                  {deleteLoading && (
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => setAddTags(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      {/* <Transition.Root show={deleteOk} as={Fragment}>
        <Dialog as="div" className="relative z-50 md:z-10 lg:z-10" onClose={() => { }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full justify-center p-4 text-center sm:items-start h-full items-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  transition
                  className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4
                   data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full
                    sm:max-w-[500px] sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <span className='font-[600]'>Delete
                    <span> {selectedRowsCount} Ticket</span>
                  </span>

                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Are you sure you want to delete your insights?
                    </p>
                  </div>
                  <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                    <button
                      type="button"
                      // onClick={handleDeleteConfirm}
                      className={`group inline-flex shrink-0 select-none
                         items-center justify-center transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline 
                         focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-1 px-[12px] dark:shadow:none border shadow-wg-xs 
                         [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50 dark:border-surface-100 py-[8px] outline-primary disabled:text-surface-300
                          text-[13px] text-dark-black-100 font-[600]
                         [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none
                      [&>span]:flex [&>span]:items-center [&>span]:gap-[8px]`}
                    >
                      Delete
                      {deleteLoading && (
                        <div className="simple-spinner">
                          <span></span>
                        </div>
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => setDeleteOk(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>

              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root> */}
    </>
  );
};

export default JobList;
